import React from 'react';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import { toggleValue } from '@ygtechnologies/rubus-frontend-utilities';
import { LocalizedEnum } from '@/types';
import { useLingui } from '@lingui/react';
import { Checkbox, CheckboxGroup } from '@ygtechnologies/rubus-ui';

interface PermissionsEditorProps<T extends string> {
    permissions: LocalizedEnum[];
    value: T[];
    onChange(value: T[]): void;
    isAdministrator: boolean;
}

function PermissionsEditor<T extends string>({ permissions, value, onChange, isAdministrator }: PermissionsEditorProps<T>) {
    const { _ } = useLingui();
    const isPermissionSelected = (permission) => {
        return !!value.find((x) => x === permission.value);
    };

    const handlePermissionChange = (e, permission) => {
        const isChecked = e.target.checked;

        const newPermissions = toggleValue(value, permission.value, isChecked);
        triggerHandler(onChange, newPermissions);
    };

    return (
        <CheckboxGroup>
            {permissions.map((p) => (
                <Checkbox
                    key={p.value}
                    inputSize="md"
                    disabled={isAdministrator}
                    checked={isPermissionSelected(p) || isAdministrator}
                    value={p.value}
                    onChange={(e) => handlePermissionChange(e, p)}>
                    {_({ id: p.textKey })}
                </Checkbox>
            ))}
        </CheckboxGroup>
    );
}

export default PermissionsEditor;
